import { render, staticRenderFns } from "./WhyMindfuliSlideshow.vue?vue&type=template&id=5326b54d&scoped=true&"
import script from "./WhyMindfuliSlideshow.vue?vue&type=script&lang=js&"
export * from "./WhyMindfuliSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./WhyMindfuliSlideshow.vue?vue&type=style&index=0&id=5326b54d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326b54d",
  null
  
)

export default component.exports